import Apertavel from '@/components/movimento/Apertavel';
import NumeroAnimado from '@/components/movimento/NumeroAnimado';

interface Props {
  icone: string;
  titulo: string;
  descricao?: string;
  /** Número grande à direita (opcional). */
  numero?: string;
  legenda?: string;
  /** Linha de alerta em amarelo, no lugar da descrição. */
  alerta?: string;
  cor?: 'primary' | 'accent' | 'secondary';
  aoClicar: () => void;
}

const CORES: Record<'primary' | 'accent' | 'secondary', string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-900',
  secondary: 'bg-secondary-100 text-secondary-900',
};

// Cartão grande de hub (≥84px): ícone, título, uma linha e número à direita.
export default function CartaoHub({
  icone,
  titulo,
  descricao,
  numero,
  legenda,
  alerta,
  cor = 'primary',
  aoClicar,
}: Props) {
  return (
    <Apertavel
      onClick={aoClicar}
      className="flex min-h-[84px] w-full cursor-pointer items-center gap-3 rounded-3xl border border-background-200 bg-white px-4 py-3.5 text-left transition-colors hover:border-primary-200 hover:bg-primary-50/40"
    >
      <span
        className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl text-xl ${CORES[cor]}`}
      >
        <i className={icone} aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[15px] font-bold text-foreground-950">{titulo}</span>
        {alerta ? (
          <span className="mt-0.5 flex items-center gap-1.5 text-[12.5px] font-semibold text-amber-800">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-alert-line" aria-hidden />
            </span>
            {alerta}
          </span>
        ) : (
          <span className="mt-0.5 block truncate text-[12.5px] text-foreground-600">
            {descricao}
          </span>
        )}
      </span>
      {numero !== undefined && (
        <span className="shrink-0 text-right">
          <span className="block whitespace-nowrap text-[17px] font-extrabold leading-none tabular-nums text-foreground-950">
            {numero !== undefined && <NumeroAnimado valor={numero} />}
          </span>
          {legenda && (
            <span className="mt-1 block whitespace-nowrap text-[11px] font-medium text-foreground-500">
              {legenda}
            </span>
          )}
        </span>
      )}
      {numero === undefined && (
        <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400">
          <i className="ri-arrow-right-s-line text-lg" aria-hidden />
        </span>
      )}
    </Apertavel>
  );
}